import { useEffect, useState } from 'react';

import { EnvironmentAndMenu } from '../../../utils/contexts';

const OSANO_SRC = 'https://cmp.osano.com/6olZmSX1cFRD2MBt/b53c21d4-1b74-4f36-8e09-bf5fb393f98d/osano.js';

/**
 * Loads Osano cookie consent script when enabled
 */
export const useOsanoScript = (env: EnvironmentAndMenu | undefined) => {
  const [osanoIsLoaded, setOsanoIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!env?.osanoEnabled) return;

    const existingScript = document.querySelector(`script[src="${OSANO_SRC}"]`);

    if (existingScript) {
      setOsanoIsLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = OSANO_SRC;
    script.async = true;
    script.onload = () => setOsanoIsLoaded(true);
    document.body.appendChild(script);
  }, [env?.osanoEnabled]);

  return osanoIsLoaded;
};
